import { apiSlice } from '@src/services/api/apiSlice';
import { DeleteUserParams } from './deleteUserApiSliceTypes';

const deleteUserApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        deleteUser: builder.mutation({
            query: ({ id }: DeleteUserParams) => ({
                url: `/users/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, _, { id }) =>
                result
                    ? [
                          { type: 'users', id },
                          { type: 'users', id: 'LIST' },
                      ]
                    : [],
        }),
    }),
    overrideExisting: true,
});

export const { useDeleteUserMutation } = deleteUserApiSlice;
